export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14299.0dcbd996.jpg";